<script lang="ts">
  /**
   * The top few communities for a keyword, revealed on hover of whatever `.group`
   * contains it. Pulse placeholders while the leaders are still loading — the caller
   * fetches on hover, so the strip is usually open before its data is.
   */
  import type { Leader } from '../../audit';
  import LeaderLogo from './LeaderLogo.svelte';
  import { keepOnScreen } from './keepOnScreen';

  let { leaders }: { leaders: Leader[] | undefined } = $props();
</script>

<!-- `w-max`: an absolutely positioned box shrink-to-fits, and that fit is capped by
     its containing block. Without it the card stops at the cell's width and the
     logos, which cannot shrink, spill out. -->
<span
  class="pointer-events-none absolute left-0 top-full z-50 mt-1 hidden hovercard
         w-max items-center gap-1.5 rounded-box p-2 shadow-lg sm:group-hover:flex
         sm:group-focus-within:flex"
  use:keepOnScreen
>
  {#each leaders ?? [] as l (l.rank)}
    <LeaderLogo leader={l} size="lg" light />
  {:else}
    {#each [0, 1, 2, 3, 4] as i (i)}
      <span class="h-9 w-9 shrink-0 animate-pulse rounded-full bg-white/25"></span>
    {/each}
  {/each}
</span>
